<template>
	<ui-modal-template>
		<template v-slot:title>
			{{ source ? __("Preisquelle bearbeiten") : __("Preisquelle anlegen") }}
		</template>

		<template v-slot:content>
			<ui-form class="h-full flex flex-col" :loading="loading" @submit="submitForm">
				<div class="p-0">
					<div class="flex flex-col px-6">
						<ui-input-group
							class="basis-full py-4"
							v-model="form.name"
							field="name"
							label="Name"
							:form="form"
							:required="true"
						/>
					</div>
				</div>

				<div class="bg-gray-100 p-6 px-6 mt-4">
					<div class="flex justify-end">
						<ui-button
							:disabled="loading"
							native-type="submit"
							label="Speichern"
						/>
					</div>
				</div>
			</ui-form>
		</template>
	</ui-modal-template>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		source: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			loading: false,
			form: Vue.observable({
				errors: {},
				hasErrors: false,
				clearErrors() {},
				name: this.source?.name ?? null,
			}),
		};
	},

	methods: {
		/**
		 * @return {void}
		 */
		async submitForm() {
			this.loading = true;

			try {
				if (this.source) {
					await axios.patch(
						this.$route("admin.price_sources.update", { id: this.source.id }),
						{ name: this.form.name }
					);
				} else {
					await axios.post(
						this.$route("admin.price_sources.store"),
						{ name: this.form.name }
					);
				}

				this.$bus.$emit("modal:close");
				this.$bus.$emit("content:load");
			} catch (error) {
				if (error.response?.status === 422) {
					this.$bus.$emit("form:invalid", error.response.data.errors);
				} else {
					this.$bus.$emit("modal:error", error);
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
